module.exports = __webpack_public_path__ + "static/img/card.f786865.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/temp/card.jpg
// module id = sUPu
// module chunks = 1